module.exports = __webpack_public_path__ + "img/DE06175.68830d04.png";